import React from 'react'
import logo from "../../../../assets/imgs/navbar/logo_AMC_azul.svg";
import "./bienvenido.css";
import bgFondo from "../../../../assets/imgs/dashboard/img-fondo-redisenio.png";


function Bienvenido() {
  

  return (
    <>
      <div className="row">
      <div className='bienvenido-container' style={{ backgroundImage: `url(${bgFondo})` }}></div>
      </div>
    </>
  )
}

export default Bienvenido